/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForTemplateGcpProvider extends models.ScheduleExecutionParameterForTemplateBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForTemplateGcpProvider");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForTemplateGcpProvider.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForTemplateGcpProvider>): ScheduleExecutionParameterForTemplateGcpProvider {
        let obj = Object.assign(new ScheduleExecutionParameterForTemplateGcpProvider(), model);
        ScheduleExecutionParameterForTemplateGcpProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForTemplateGcpProvider>): ScheduleExecutionParameterForTemplateGcpProvider {
        if (!model) return null;
        return ScheduleExecutionParameterForTemplateGcpProvider.newInstance(<ScheduleExecutionParameterForTemplateGcpProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForTemplateGcpProvider) {
        if (!obj) return;

        models.ScheduleExecutionParameterForTemplateGcpProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForTemplateGcpProvider): boolean {
        if (models.ScheduleExecutionParameterForTemplateBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForTemplateGcpProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The zone of the cloud account where it needs to be executed.
     */
    zone: string;

}
